import type { LogDto } from '../types/LogDto';
import  { get } from './config';

export function addMeta(payloadOriginal: LogDto, applicationUid: string | null = null): LogDto {
    const payload: LogDto = { ...payloadOriginal };

    if (typeof window === 'undefined') return payload;

    const chayns = (window as any).chayns;
    const chaynsEnv: boolean = chayns && chayns.env;

    if (!payload.personId) {
        if (get('personId', applicationUid)) {
            payload.personId = get('personId', applicationUid);
        } else if (chaynsEnv && chayns.env.user && chayns.env.user.personId) {
            payload.personId = chayns.env.user.personId;
        }
    }

    if (!payload.locationId) {
        if (get('locationId', applicationUid)) {
            payload.locationId = get('locationId', applicationUid);
        } else if (chaynsEnv && chayns.env.site && chayns.env.site.locationId) {
            payload.locationId = chayns.env.site.locationId;
        }
    }

    return payload;
}
